export { default } from './TextareaAutosize';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/TextareaAutosize/index.js
// module id = 602
// module chunks = 121